



















import { SpotWidgetDataMixin } from '@/features/core/components/spot-widget-control/data-mixin';
import { Component, Mixins } from 'vue-property-decorator';
import bgImage from './relais-lg.svg';

@Component
export default class RelaisDevicePanel extends Mixins(SpotWidgetDataMixin) {
  private backgroundImage = bgImage;
}
